import _ from 'lodash'
import { createAction, handleActions } from 'redux-actions'

/////////////////
//// Actions ////
/////////////////

const BASE_ACTION_NAME = 'presentation'

// websocket
export const CHANNEL_NAME = 'PresentationChannel'
export const RECEIVE_CHANGE_STATUS = createAction(`${BASE_ACTION_NAME}/receive_change_status`)
export const RECEIVE_CHANGE_PARTICIPANT = createAction(`${BASE_ACTION_NAME}/receive_change_participant`)
export const WAIT_WEBSOCKET = createAction(`${BASE_ACTION_NAME}/wait_websocket`)

// API
export const FETCH_PROJECT = createAction(`${BASE_ACTION_NAME}/fetch_project/`)
export const FETCH_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/fetch_project/success`)
export const FETCH_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/fetch_project/failure`)

export const FETCH_RANKING = createAction(`${BASE_ACTION_NAME}/FETCH_RANKING/`)
export const FETCH_RANKING_SUCCESS = createAction(`${BASE_ACTION_NAME}/FETCH_RANKING/success`)
export const FETCH_RANKING_FAILURE = createAction(`${BASE_ACTION_NAME}/FETCH_RANKING/failure`)

export const FETCH_ANSWER_COUNT = createAction(`${BASE_ACTION_NAME}/FETCH_ANSWER_COUNT/`)
export const FETCH_ANSWER_COUNT_SUCCESS = createAction(`${BASE_ACTION_NAME}/FETCH_ANSWER_COUNT/success`)
export const FETCH_ANSWER_COUNT_FAILURE = createAction(`${BASE_ACTION_NAME}/FETCH_ANSWER_COUNT/failure`)

export const CHANGE_REALTIME_ANSWER_CHOICE = createAction(`${BASE_ACTION_NAME}/change_realtime_answer_choice/`)

export const UPDATE_REALTIME_ANSWER_CHOICE = createAction(`${BASE_ACTION_NAME}/update_realtime_answer_choice`)
export const UPDATE_REALTIME_ANSWER_CHOICE_SUCCESS = createAction(
  `${BASE_ACTION_NAME}/update_realtime_answer_choice/success`
)
export const UPDATE_REALTIME_ANSWER_CHOICE_FAILURE = createAction(
  `${BASE_ACTION_NAME}/update_realtime_answer_choice/failure`
)

/////////////////
//// Reducer ////
/////////////////

const initialState = {
  project: {
    id: null,
    questions: []
  },
  ranking: [],
  isRankingFetched: false,
  phase: 0,
  index: 0,
  type: -1,
  participantCount: 0,
  isPresentationLoading: false,
  isControllerLoading: false,
  isRankingFetching: false
}

const setAnswerChoiceId = (questions, questionIndex, answerChoiceId) => {
  if (!answerChoiceId) {
    return questions
  }
  let newQuestions = _.cloneDeep(questions)
  if (newQuestions[questionIndex]) {
    newQuestions[questionIndex]['answer_choice_id'] = answerChoiceId
  }
  return newQuestions
}

export default handleActions(
  {
    [WAIT_WEBSOCKET]: state => ({
      ...state,
      isControllerLoading: true
    }),

    [RECEIVE_CHANGE_STATUS]: (state, { payload }) => ({
      ...state,
      phase: payload.phase,
      index: payload.index,
      type: payload.type,
      answerCount: payload.answerCount,
      isControllerLoading: false,
      project: {
        ...state.project,
        questions: setAnswerChoiceId(state.project.questions, payload.index, payload.answer)
      }
    }),

    [RECEIVE_CHANGE_PARTICIPANT]: state => ({
      ...state,
      participantCount: state.participantCount + 1
    }),

    [FETCH_PROJECT_SUCCESS]: (state, action) => ({
      ...state,
      project: action.payload.data
    }),

    [FETCH_RANKING]: state => ({
      ...state,
      isControllerLoading: true,
      isPresentationLoading: true,
      isRankingFetching: true
    }),

    [FETCH_RANKING_SUCCESS]: (state, action) => ({
      ...state,
      ranking: action.payload.data.result,
      isRankingFetched: true,
      isControllerLoading: false,
      isPresentationLoading: false
    }),

    [FETCH_ANSWER_COUNT_SUCCESS]: (state, action) => {
      const project = _.cloneDeep(state.project)
      if (project.questions[state.index]) {
        project.questions[state.index].allAnswerCount = action.payload.data.all
      }

      return {
        ...state,
        project: project
      }
    },

    [CHANGE_REALTIME_ANSWER_CHOICE]: (state, action) => ({
      ...state,
      project: {
        ...state.project,
        questions: setAnswerChoiceId(state.project.questions, state.index, action.payload)
      }
    })
  },
  initialState
)
